import { createRouter, createWebHistory } from "vue-router";
// import isAdmin from './middleware/AccessIfAdmin.js';
import adminAuth from './middleware/admin/Authenticate.js';
import AccessIfLogged from './middleware/admin/AccessIfLogged.js';
import AccessIfAdmin from './middleware/admin/AccessIfAdmin.js';
import middlewarePipeline from './middleware/admin/MiddlewarePipeline.js';
import customerAuth from './middleware/customer/Authenticate.js';
import { ACTION_MODE } from "./common/constants.js";

// Customer component
const CustomerHome = () => import('./pages/customer/Home.vue');
const CustomerMaterial = () => import('./pages/customer/material/List.vue');

const CustomerCart = () => import('./pages/customer/cart/List.vue');
const CustomerPayment = () => import('./pages/customer/cart/Payment.vue');

const CustomerLogin = () => import('./pages/customer/auth/Login.vue');
const CustomerRegister = () => import('./pages/customer/auth/Register.vue');
const CustomerForgot = () => import('./pages/customer/auth/Forgot.vue');
const CustomerResetPassword = () => import('./pages/customer/auth/ResetPassword.vue');
const CustomerGallery = () => import('./pages/customer/gallery/List.vue');
const CustomerAddFavorite = () => import('./pages/customer/myWishlist/List.vue');
const CustomerGetForRoom = () => import('./pages/customer/room/List.vue');
const CustomerGetListRoomType = () => import('./pages/customer/room/Type.vue');
const CustomerGetRoomDetail = () => import('./pages/customer/room/Detail.vue');
const CustomerGetMyAccount = () => import('./pages/customer/auth/information/MyAccount.vue');
const CustomerEditInfor = () => import('./pages/customer/auth/information/Edit.vue');
const CustomerEditPassoword = () => import('./pages/customer/auth/information/ChangePassword.vue');
const CustomerOrder = () => import('./pages/customer/auth/information/order/List.vue');
const CustomerOrderDetail = () => import('./pages/customer/auth/information/order/Detail.vue');
const CustomerSearch = () => import('./pages/customer/search/List.vue');
const CustomerContact = () => import('./pages/customer/contact/Form.vue');

// Admin component
const AdminHome = () => import("./pages/admin/Home.vue");
const AdminLogin = () => import("./pages/admin/Login.vue");
const AdminChangePass = () => import("./pages/admin/ChangePassword.vue");

const AdminRoom = () => import("./pages/admin/room/List.vue");
const AdminRoomCreate = () => import("./pages/admin/room/Create.vue");

const AdminRoomType = () => import("./pages/admin/roomType/List.vue");
const AdminRoomTypeCreate = () => import("./pages/admin/roomType/Create.vue");

const AdminMaterialType = () => import("./pages/admin/materialType/List.vue");
const AdminMaterialTypeCreate = () => import("./pages/admin/materialType/Create.vue");

const AdminMaterial = () => import("./pages/admin/material/List.vue");
const AdminMaterialCreate = () => import("./pages/admin/material/Create.vue");

const AdminSocial = () => import("./pages/admin/social/List.vue");
const AdminSocialCreate = () => import("./pages/admin/social/Create.vue");

const AdminProduct = () => import("./pages/admin/product/List.vue");
const AdminProductCreate = () => import("./pages/admin/product/Create.vue");

const AdminHrm = () => import("./pages/admin/hrm/List.vue");
const AdminHrmCreate = () => import("./pages/admin/hrm/Create.vue");

const AdminCustomer = () => import("./pages/admin/customer/List.vue");
const AdminCustomerUpdate = () => import("./pages/admin/customer/Update.vue");

const AdminOrder = () => import("./pages/admin/order/List.vue");

const AdminInformationUpdate = () => import("./pages/admin/information/Update.vue");

const AdminContact = () => import("./pages/admin/contact/List.vue");
const AdminContactDetail = () => import("./pages/admin/contact/Detail.vue");

const AdminGallery = () => import("./pages/admin/gallery/List.vue");

const router = createRouter({
    history: createWebHistory(),
    routes: [
        // Customer route
        {
            path: "/login",
            name: "login",
            component: CustomerLogin,
        },
        {
            path: "/register",
            name: "register",
            component: CustomerRegister,
        },
        {
            path: "/forgot",
            name: "forgot",
            component: CustomerForgot,
        },
        {
            path: "/reset-password",
            name: "reset-password",
            component: CustomerResetPassword,
        },
        {
            path: "/",
            name: "home",
            component: CustomerHome,
        },
        {
            path: "/materials",
            name: "materials",
            component: CustomerMaterial,
        },
        {
            path: "/cart",
            name: "cart",
            component: CustomerCart,
        },
        {
            path: "/cart/payment",
            name: "get-payment",
            component: CustomerPayment,
        },
        {
            path: "/gallery",
            name: "gallery",
            component: CustomerGallery,
        },

        {
            path: "/my-wishlist",
            name: "my-wishlist",
            component: CustomerAddFavorite,
        },

        {
            path: "/rooms",
            name: "rooms",
            component: CustomerGetForRoom,
        },

        {
            path: "/rooms/:slug",
            name: "room-type",
            component: CustomerGetListRoomType,
        },

        {
            path: "/room/:slug/:slugDetail",
            name: "room-detail",
            component: CustomerGetRoomDetail,
        },

        {
            path: "/my-account",
            name: "my-account",
            component: CustomerGetMyAccount,
            meta: {
                middleware: [customerAuth],
            },
        },

        {
            path: "/my-account/edit/information/",
            name: "edit-infor",
            component: CustomerEditInfor,
        },

        {
            path: "/my-account/edit/password",
            name: "edit-password",
            component: CustomerEditPassoword,
        },

        {
            path: "/my-account/order",
            name: "order",
            component: CustomerOrder,
            meta: {
                middleware: [customerAuth],
            },
        },

        {
            path: "/my-account/order/detail/:orderDetail",
            name: "order-detail",
            component: CustomerOrderDetail,
            meta: {
                middleware: [customerAuth],
            },
        },

        {
            path: "/search",
            name: "search",
            component: CustomerSearch,
        },

        {
            path: "/contact",
            name: "contact",
            component: CustomerContact,
        },

        // Admin route
        {
            path: "/admin",
            name: "admin-home",
            meta: {
                middleware: [adminAuth],
            },
            component: AdminHome,
        },
        {
            path: "/admin/login",
            name: "admin-login",
            meta: {
                middleware: [AccessIfLogged],
            },
            component: AdminLogin,
        },
        {
            path: "/admin/change-password",
            name: "admin-change-password",
            meta: {
                middleware: [adminAuth],
            },
            component: AdminChangePass,
        },
        {
            path: "/admin/room",
            name: "admin-room",
            component: AdminRoom,
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/room/create",
            name: "admin-room-create",
            component: AdminRoomCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/room/update/:id",
            name: "admin-room-update",
            component: AdminRoomCreate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/room/:roomId/type",
            name: "admin-roomType",
            component: AdminRoomType,
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/room/:roomId/type/create",
            name: "admin-roomType-create",
            component: AdminRoomTypeCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/room/:roomId/type/update/:typeId",
            name: "admin-roomType-update",
            component: AdminRoomTypeCreate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/material/type",
            name: "admin-material-type",
            component: AdminMaterialType,
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/material/type/create",
            name: "admin-material-type-create",
            component: AdminMaterialTypeCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/material/type/update/:id",
            name: "admin-material-type-update",
            component: AdminMaterialTypeCreate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/material",
            name: "admin-material",
            component: AdminMaterial,
        },
        {
            path: "/admin/material/create",
            name: "admin-material-create",
            component: AdminMaterialCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/material/update/:id",
            name: "admin-material-update",
            component: AdminMaterialCreate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/social",
            name: "admin-social",
            component: AdminSocial,
            // meta: {
            //     middleware: isAdmin,
            // }
        },
        {
            path: "/admin/social/create",
            name: "admin-social-create",
            component: AdminSocialCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            // meta: {
            //     middleware: isAdmin,
            // }
        },
        {
            path: "/admin/product",
            name: "admin-product",
            component: AdminProduct,
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/product/create",
            name: "admin-product-create",
            component: AdminProductCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/product/update/:id",
            name: "admin-product-update",
            component: AdminProductCreate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/social",
            name: "admin-social",
            component: AdminSocial,
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/social/create",
            name: "admin-social-create",
            component: AdminSocialCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/social/update/:id",
            name: "admin-social-update",
            component: AdminSocialCreate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/hrm",
            name: "admin-hrm",
            component: AdminHrm,
            meta: {
                middleware: [adminAuth, AccessIfAdmin],
            }
        },
        {
            path: "/admin/hrm/create",
            name: "admin-hrm-create",
            component: AdminHrmCreate,
            props: {
                mode: ACTION_MODE.CREATE,
            },
            meta: {
                middleware: [adminAuth, AccessIfAdmin],
            }
        },
        {
            path: "/admin/hrm/update/:id",
            name: "admin-hrm-update",
            component: AdminHrmCreate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth, AccessIfAdmin],
            }
        },
        {
            path: "/admin/customer",
            name: "admin-customer",
            component: AdminCustomer,
            meta: {
                middleware: [adminAuth, AccessIfAdmin],
            }
        },
        {
            path: "/admin/customer/update/:id",
            name: "admin-customer-update",
            component: AdminCustomerUpdate,
            props: {
                mode: ACTION_MODE.UPDATE,
            },
            meta: {
                middleware: [adminAuth, AccessIfAdmin],
            }
        },
        {
            path: "/admin/order",
            name: "admin-order",
            component: AdminOrder,
            meta: {
                middleware: [adminAuth, AccessIfAdmin],
            }
        },
        {
            path: "/admin/information",
            name: "admin-information-update",
            component: AdminInformationUpdate,
            meta: {
                middleware: [adminAuth, AccessIfAdmin],
            }
        },
        {
            path: "/admin/contact",
            name: "admin-contact",
            component: AdminContact,
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/contact/:id",
            name: "admin-contact-detail",
            component: AdminContactDetail,
            meta: {
                middleware: [adminAuth],
            }
        },
        {
            path: "/admin/gallery",
            name: "admin-gallery",
            component: AdminGallery,
            meta: {
                middleware: [adminAuth],
            }
        },
    ],
    linkActiveClass: "active",
    linkExactActiveClass: "active",
});

router.beforeEach((to, from, next) => {
    const middleware = to.meta.middleware;
    const context = { to, from, next };

    // Check if no middlware on route
    if (!middleware) {
        return next();

    }

    middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1),
    });
});

export default router;
